export default __webpack_public_path__ + "static/media/graignes11.7901867f.jpg";